import { Text, View } from "@react-pdf/renderer";
import styles from "./components/Styles";
import { Permit } from "../../models/Permit";
import Row from "./components/Row";
import Item from "./components/Item";
import moment from "moment";
import { PermitToDigSignatureType } from "../../models/globalTypes";
import Break from "./components/Break";
import HeaderText from "./components/HeaderText";

interface Props {
  permit: Permit;
}

const DeclarationsPage = ({ permit }: Props) => {
  if (!permit) return null;

  const submissionSignature = permit.signatures.find((s) => s.type === PermitToDigSignatureType.SUBMISSION);
  const requestSignature = permit.signatures.find((s) => s.type === PermitToDigSignatureType.REQUEST);
  return (
    <>
      <HeaderText title="DECLARATIONS" />
      <View
        style={{ backgroundColor: "whitesmoke", border: "1px solid #666", borderTop: 0, padding: "0px 10px 0px 10px" }}
      >
        <View wrap={false}>
          <HeaderText title="REQUEST" backgroundColor="#999" />
          <View style={{ backgroundColor: "whitesmoke", border: "1px solid #666", borderTop: 0 }}>
            {requestSignature?.declaration.split(/\r?\n/).map((d) => (
              <Text style={{ ...styles.text, margin: "3px 5px", color: "#444", fontSize: 10 }}>{d}</Text>
            ))}
          </View>
          <Row border>
            <Item
              width="33%"
              title="Requested by"
              text={`${requestSignature?.orgUser?.user.firstName || ""} ${
                requestSignature?.orgUser?.user.lastName || ""
              }`}
            ></Item>
            <Item
              width="33%"
              title="Date"
              text={requestSignature?.dateSignedUtc ? moment(requestSignature.dateSignedUtc)?.format("lll") : "-"}
            ></Item>
          </Row>
          <Break height={5} />
        </View>

        <View wrap={false}>
          <HeaderText title="PRE-SUBMISSION" backgroundColor="#999" />
          <View style={{ backgroundColor: "whitesmoke", border: "1px solid #666", borderTop: 0 }}>
            {submissionSignature?.declaration.split(/\r?\n/).map((d) => (
              <Text style={{ ...styles.text, margin: "3px 5px", color: "#444", fontSize: 10 }}>{d}</Text>
            ))}
          </View>
          <Row border>
            <Item
              width="33%"
              title="Submitted by"
              text={`${submissionSignature?.orgUser?.user.firstName || ""} ${
                submissionSignature?.orgUser?.user.lastName || ""
              }`}
            ></Item>
            <Item
              width="33%"
              title="Date"
              text={submissionSignature?.dateSignedUtc ? moment(submissionSignature.dateSignedUtc)?.format("lll") : "-"}
            ></Item>
          </Row>
          <Break height={5} />
        </View>
      </View>

      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
    </>
  );
};

export default DeclarationsPage;
